import React, { useEffect, useState } from "react";
import logo from "../asset/logo.png";
import Dropdown from 'react-bootstrap/Dropdown';
import "../navbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { isLoggedIn, logout } from "./../service/authService";
import RegisterKit from "./registerKit";
import { Button } from "react-bootstrap";

function Navbar2() {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoggedIn1, setIsLoggedIn] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleRegisterKit = () => {
        handleClose();
        navigate("/register");
    };
    const loginType = localStorage.getItem("loginType");



    useEffect(() => {
        const checkLoggedIn = async () => {
            // Skip check if on admin route
            if (location.pathname.startsWith("/admin")) return;

            const loggedIn = await isLoggedIn();
            setIsLoggedIn(loggedIn);

            if (!loggedIn && location.pathname !== "/registerpage" && location.pathname?.toLocaleLowerCase() !== "/passwordreset" && location.pathname?.toLocaleLowerCase() !== "/forgotpassword") {
                navigate("/login");
            } else if (loggedIn) {
                const token = localStorage.getItem("userInfo");
                const userInfo = JSON.parse(token);
                // You can use userInfo here if needed
            }
        };

        checkLoggedIn();
    }, [navigate, location.pathname]);

    function logoutHandler() {
        logout(); // Clear localStorage/session
        
        if (location.state?.fromAdmin) {
            navigate('/admin', { replace: true }); // ✅ Admin login page
        } else {
            navigate('/login', { replace: true }); // ✅ Normal login page
        }
    }
    const goToHome = (route) => {
        navigate("/" + route, { replace: true });
    };


  const shouldShowSignOut =
        isLoggedIn &&
        !location.pathname.startsWith('/login') &&
        !location.pathname.startsWith('/admin') &&
        ((loginType === 'microsoft') || loginType === 'normal');


console.log("Login Type:",shouldShowSignOut, loginType,location.pathname);
    return (
        <div className="navTab">
            <a className="navTabTitle" >
                {/* <span style={{ fontSize: '1em' }}>
                    <span style={{ color: '#f40000', fontWeight: 'bold' }}>BLASTOFF</span>
                </span> */}
                <img className="logo1" src={logo} alt="logo" />

            </a>
            <div className="navTabChild">
                <ul>
                    <Dropdown className="nav_item">
                        <li>
                            <Dropdown.Item onClick={() => goToHome('home')}>HOME</Dropdown.Item>
                        </li>

                        <Dropdown.Item href="https://petivitybrands.myshopify.com/products/dog-nutritional-dna-analysis-kit"
                            target="_blank" rel="noopener noreferrer">
                            SHOP
                        </Dropdown.Item>

                        <li>
                            <Dropdown.Item href="https://petivitybrands.myshopify.com/pages/how-it-works">HOW IT WORKS</Dropdown.Item>
                        </li>
                        <li>
                            <Dropdown.Item href="https://petivitybrands.myshopify.com/pages/contact">CONTACT</Dropdown.Item>
                        </li>

                    </Dropdown>
                </ul>
            </div>

            {/* {isLoggedIn1 && (
                <div className="button2Container">
                    <Button className="button2" onClick={logoutHandler}>Sign Out</Button>
                </div>
            )} */}

       {shouldShowSignOut && (
                <div className="button2Container">
                    <Button className="button2" onClick={logoutHandler}>Sign Out</Button>
                </div>
            )}

            <RegisterKit show={show} handleClose={handleClose} />
        </div>
    );
}

export default Navbar2;
